module.exports = __webpack_public_path__ + "media/images/flags/us-0fffdc4abb38bf1ad94ba5e1295d53c7.svg";